import React from 'react';
import ArrowLeft from '../../Assets/Arrow left.svg';
import { Link, useLocation } from 'react-router-dom';
import SalesByCategoryGraph from './Components/SalesByCategory.Graph';
import ChevronDown from '../../Assets/Dropdown/ChevronDown.svg';

function SalesByCategory() {
    const location = useLocation();

    const data = [
        {
            name: "Men Clothing",
            percentage: 52,
        },
        {
            name: "Women clothing",
            percentage: 2,
        },
        {
            name: "Handbags",
            percentage: 15,
        },
        {
            name: "Fashion Accessories",
            percentage: 52,
        },
        {
            name: "Footwear",
            percentage: 32,
        },
        {
            name: "Kids",
            percentage: 29,
        },
        {
            name: "Teens",
            percentage: 52,
        },
    ];

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">Sales by Category</h1>
                </div>

                <div className="flex gap-4">
                    {<button onClick={() => {}} className='bg-primaryColor hover:bg-primaryAccent rounded-md px-3 py-[10px] text-buttonText font-semibold text-[14px] leading-[22px]'>
                        Download Report
                    </button>}

                    <button onClick={() => {}} className="cursor-pointer rounded-md border border-[#EAEAEA] p-[10px_2px_10px_8px] flex items-center gap-1">
                        <p className='w-20 font-semibold text-[14px] leading-[22px] text-[#121212] text-left whitespace-nowrap'>Last 30 days</p>

                        <div className="size-[22px] flex items-center justify-center">
                            <img src={ChevronDown} alt="" />
                        </div>
                    </button>
                </div>
            </div>

            <div className="flex mt-3 mx-5">
                <SalesByCategoryGraph 
                    salesByCategoryData={data}
                />
            </div>
        </div>
    );
}

export default SalesByCategory;
